/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { IdentityRef } from './';
import {
    IdentityRefFromJSON,
    IdentityRefFromJSONTyped,
    IdentityRefToJSON,
} from './';
import type { PhotoResponse } from './';
import {
    PhotoResponseFromJSON,
    PhotoResponseFromJSONTyped,
    PhotoResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientUserResource
 */
export interface ClientUserResource {
    /**
     * 
     * @type {IdentityRef}
     * @memberof ClientUserResource
     */
    identityRef: IdentityRef;
    /**
     * 
     * @type {string}
     * @memberof ClientUserResource
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ClientUserResource
     */
    companyName?: string;
    /**
     * 
     * @type {PhotoResponse}
     * @memberof ClientUserResource
     */
    photo?: PhotoResponse;
}

/**
 * Check if a given object implements the ClientUserResource interface.
 */
export function instanceOfClientUserResource(value: object): value is ClientUserResource {
    if (!('identityRef' in value) || value['identityRef'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function ClientUserResourceFromJSON(json: any): ClientUserResource {
    return ClientUserResourceFromJSONTyped(json, false);
}

export function ClientUserResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientUserResource {
    if (json == null) {
        return json;
    }
    return {
        
        'identityRef': IdentityRefFromJSON(json['identityRef']),
        'name': json['name'],
        'companyName': json['companyName'] == null ? undefined : json['companyName'],
        'photo': json['photo'] == null ? undefined : PhotoResponseFromJSON(json['photo']),
    };
}

export function ClientUserResourceToJSON(value?: ClientUserResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'identityRef': IdentityRefToJSON(value['identityRef']),
        'name': value['name'],
        'companyName': value['companyName'],
        'photo': PhotoResponseToJSON(value['photo']),
    };
}

